import ViewAllReports from '../Screens/Admin Page/ViewAllReports'

export const view_admin_reports_tabs = [
  {
    id: 1,
    title: 'All Technical Reports',
    page: <ViewAllReports/>,
  }
]